<template>
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
            <h2 class="text-2xl font-semibold mb-4">Add Schedule</h2>
            <form>
                <div class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2" for="title">
                        Title
                    </label>
                    <input id="title" type="text"
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        v-model="title" />
                </div>
                <div class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2" for="date">
                        Note
                    </label>
                    <textarea
                        id="description"
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        v-model="description"
                    ></textarea>
                </div>
                <div class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2" for="date">
                        Date
                    </label>
                    <input
                        id="date"
                        type="date"
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        v-model="date"
                    />
                </div>
                <div class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2" for="time">
                        Time
                    </label>
                    <input
                        id="time"
                        type="time"
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        v-model="time"
                    />
                </div>
                <div class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2" for="link">
                        Link
                    </label>
                    <input id="link" type="text"
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        v-model="link" />
                </div>
                <div class="flex items-center justify-end">
                    <button
                        type="button"
                        class="bg-gray-500 text-white px-4 py-2 rounded mr-2 hover:bg-gray-600"
                        @click="closeForm"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                        @click="handleSubmit"
                    >
                        Add Schedule
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { addSchedule } from '../../../services/teacherService';
import { ref } from 'vue';

const date = ref('');
const time = ref('');
const title = ref('');
const description = ref('');
const link = ref('');

const emit = defineEmits(['close']);

const handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
        await addSchedule(props.subscription.id, {
            date: date.value,
            time: time.value,
            title: title.value,
            description: description.value,
            link: link.value
        });
        closeForm();
    } catch (error) {
        console.error('Error adding schedule:', error);
    }
};

const props = defineProps({
    subscription: {
        type: Object,
        required: true
    }
});

const closeForm = () => {
    emit('close');
};
</script>